import React, { useCallback, useState } from "react";
import { PlaidConnection } from "@common/types/plaidConnection";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { simulateRevokeConnectionPermissions } from "@lib/simulations";

interface ExternalConnectionRowProps {
    connection: PlaidConnection;
}

export const ExternalConnectionRow: React.FC<ExternalConnectionRowProps> = ({
    connection,
}) => {
    const [revoking, setRevoking] = useState(false);

    const revoke = useCallback(async () => {
        await simulateRevokeConnectionPermissions(connection.id);
    }, [connection.id]);

    return (
        <tr>
            <td>{connection.id}</td>
            <td>{connection.user?.email ?? "Deleted"}</td>
            <td>{connection.bankName}</td>
            <td>
                <ButtonWithLoader
                    variant="primary"
                    size="md"
                    loading={revoking}
                    setLoading={setRevoking}
                    onClick={revoke}
                    className="mr-2"
                >
                    Revoke permissions
                </ButtonWithLoader>
            </td>
        </tr>
    );
};
